import { Reducer } from 'typesafe-actions';

// add the reducer key value here to have loading behavior
const storeKeys = ['widgets', 'account', 'sso'];

export default storeKeys;

export type StoreKeys = (typeof storeKeys)[number];
export interface LoadingField {
    readonly isLoading?: boolean;
}

export type LoadingState = {
    [k in StoreKeys]: LoadingField;
};

export const initialState = storeKeys.reduce(
    (acc, curr) => ({
        ...acc,
        [curr]: {
            isLoading: false
        }
    }),
    {} as LoadingState
);

/* eslint-disable @typescript-eslint/no-explicit-any */
export const loading: Reducer<LoadingState, any> = (state: LoadingState = initialState, action = {}) => {
    const isRequest = action.type.endsWith('REQUEST'),
        storeKey = action.type.substr(0, action.type.indexOf('/')),
        success = action.type.endsWith('SUCCESS'),
        failure = action.type.endsWith('FAILURE');

    const isStoreKey = storeKeys.indexOf(storeKey) !== -1;

    if (isRequest && isStoreKey) {
        return {
            ...state,
            [storeKey]: {
                isLoading: true
            }
        };
    } else if (success || failure) {
        return {
            ...state,
            [storeKey]: {
                isLoading: false
            }
        };
    }
    return state;
};
